import cn from 'classnames';
import { type HVStackProps, VStack } from '@direct-frontend/components';
import styles from './DialogContent.module.css';

export const DialogContent = (props: HVStackProps) => {
    const { className, children, ...other } = props;

    return (
        <VStack {...other} className={cn(className, styles.container)}>
            {children}
        </VStack>
    );
};
